/**
 * Okta情報取得条件VO
 *
 * @export GetOktaInfomationModel
 * @class GetOktaInfomationModel
 */
export class GetOktaInfomationModel {
  // ユーザ名（漢字）
  public UserNmKanji = String('');
  // 所属部署名
  public UserDeptNm = String('');
}
